import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Polygon, Polyline } from '@react-google-maps/api';
import wrapSymbolPath from '@shared/symbol-path-wrapper';
import { generatePath, generatePolygonPaths, zipCoordinatePair } from '@utils/map-utils';

// eslint-disable-next-line react/display-name
const MapFigure = memo(({
  editable,
  onMouseUp,
  setPolygonRef,
  shape,
  ...other
}) => {
  const renderPolygon = () => {
    let drawingProps = {};
    if (editable) {
      // Properties that are only needed in drawing mode.
      drawingProps = {
        ref: setPolygonRef,
        onMouseUp
      };
    }
    return (
      <Polygon {...other} paths={generatePolygonPaths(shape.coordinates)} {...drawingProps} />
    );
  };

  const renderPolyline = () => (
    <Polyline {...other} path={generatePath(shape.coordinates)} />
  );

  const renderPoint = () => (
    <Polyline {...other} path={[zipCoordinatePair(shape.coordinates), zipCoordinatePair(shape.coordinates)]} />
  );

  // Render based on shape type
  if (shape.type === 'Polygon' || shape.type === 'MultiLineString') {
    return renderPolygon();
  }
  if (shape.type === 'LineString') {
    return renderPolyline();
  }
  if (shape.type === 'Point') {
    return renderPoint();
  }
  return null;
});

MapFigure.propTypes = {
  editable: PropTypes.bool,
  onMouseUp: PropTypes.func,
  options: PropTypes.object,
  setPolygonRef: PropTypes.func,
  shape: PropTypes.object.isRequired
};

export default wrapSymbolPath(MapFigure);
